import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import { ConditionLevelSelectContainer } from '../../../ConditionActionsBase';

interface Props {
  supplierNumber?: number;
}

export function LevelStep({ supplierNumber }: Props) {
  return (
    <SuspenseWithSentryErrorBoundary>
      <ConditionLevelSelectContainer supplierNumber={supplierNumber}>
        {() => null}
      </ConditionLevelSelectContainer>
    </SuspenseWithSentryErrorBoundary>
  );
}
